import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHFeriadoUpd = async (credentials, data) => {
  const body = {
    service: "RNHFeriadoUpd",
    params: {
      rnhFeriadoId: data?.id || null,
      rnhFeriadoNombre: data?.nombre || null,
      rnhFeriadoTipo: data?.tipo || null,
      rnhFeriadoVersion: data?.version ?? null
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
